/**
 * URL policy for rendered markdown (`Markdown.tsx`, `ReviewMarkdown.tsx`).
 *
 * react-markdown's `defaultUrlTransform` keeps only http(s)/mailto/irc/xmpp
 * and blanks every other href — which is what stops `javascript:` and must
 * stay. One addition: `file:///abs/path` links (employees link local PDFs in
 * review docs) are rewritten to `jarvis://open?path=…`. Browsers refuse to
 * navigate from an http(s) page to `file://`, but they hand custom schemes
 * to the OS, where the Jarvis Helper Mac app opens the file
 * (`apps/jarvis-mac/…/LocalFileOpener.swift` owns the what-may-open policy).
 */
import { defaultUrlTransform } from "react-markdown";

export const LOCAL_OPEN_PREFIX = "jarvis://open?path=";

export function markdownUrlTransform(url: string): string {
  if (/^file:\/\//i.test(url)) {
    let path: string;
    try {
      path = decodeURI(new URL(url).pathname);
    } catch {
      return "";
    }
    return path.startsWith("/") ? localOpenUrl(path) : "";
  }
  return defaultUrlTransform(url);
}

/** The `jarvis://open` link for an absolute local path. */
export function localOpenUrl(path: string): string {
  return LOCAL_OPEN_PREFIX + encodeURIComponent(path);
}

export function isLocalOpenUrl(href: string | undefined): boolean {
  return !!href && href.startsWith(LOCAL_OPEN_PREFIX);
}
